import { cloneDeep } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'

import { attach, isArrayNotEmpty, serviceTemplate } from '@/utils'

export default {
  mixins: [
    serviceTemplate({
      serviceName: Services.routingRules,

      inputFilter(result) {
        if (isArrayNotEmpty(result.ProviderGroups)) {
          result._ProviderGroups = cloneDeep(result.ProviderGroups)
          result.ProviderGroups = result.ProviderGroups.map(item => {
            return {
              id: item.id,
              percentage: item.percentage,
              $attach: true
            }
          })
        } else {
          result.ProviderGroups = []
        }

        return result
      },
      outputFilter(result) {
        if (isArrayNotEmpty(result.ProviderGroups)) {
          attach(result, 'ProviderGroups')
        } else {
          result.ProviderGroups = undefined
        }

        return result
      },

      find: {
        defaultFilter: {
          type: undefined,
          isActive: true
        }
      },

      formClass: '',
      width: 500
    })
  ]
}
